import { AxiosError, AxiosResponse } from "axios";

// Define the expected response structure
interface ApiResponseData {
  message?: string;
  [key: string]: any;
}

export function getAxiosResponse(
  e: unknown
): AxiosResponse<ApiResponseData> | null {
  const err = e as AxiosError<ApiResponseData>;
  return err.response ?? null;
}
